const servers = {
  development: {
    main: 'https://s1.dev.houselink.info',
    second: 'https://s2.dev.houselink.info',
    web: 'https://web.houselink.com.vn'
  },
  production_dev: {
    main: 'https://s3.dev.houselink.info',
    second: 'https://s4.dev.houselink.info',
    web: 'https://web.dev.houselink.info'
  },
  production_empty: {
    main: 'https://s5.dev.houselink.info',
    second: 'https://s6.dev.houselink.info',
    web: 'https://demo.dev.houselink.info'
  },
  localhost: {
    main: 'https://localhost:3000',
    second: 'http://localhost:4444',
    web: 'https://localhost:3333'
  }
};

const api_mode = window.localStorage.getItem('admin_api_mode') || 'production_empty';
console.log('api_mode', api_mode);
const server = servers[api_mode];
const HOST = server.main;
const HOST_SECOND = server.second;
const HOST_WEB = server.web;

const HOST_CMS = "https://cms.houselink.info";

console.log({ HOST, HOST_SECOND, HOST_WEB });

export { HOST, HOST_SECOND, HOST_CMS, HOST_WEB }



// WEBPACK FOOTER //
// ./src/constants/API.js